import { isEmpty } from 'lodash';
import React, { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import errorIcon from 'src/assets/images/error-icon.svg';
import { Address } from 'src/components/Sell/MailACheck/Address';
import config from 'src/config/config';
import PdfSendCheckCharity from 'src/assets/docs/send-check-charity-sample.pdf';
import PdfMailCheckAddress from 'src/assets/docs/mail-check-address-sample.pdf';
import { selectBank } from 'src/redux/modules/bankSelection';
import { updateSelectedSchool } from 'src/redux/modules/schoolSelection';
import { getSelectedBank } from 'src/redux/modules/bankSelection/bankSelection.selectors';
import { showMoreBanks } from 'src/redux/modules/existingBanks/existingBanks.module';
import { getEligibleBanks } from 'src/redux/modules/existingBanks/existingBanks.selectors';
import {
  getCollegePlanType,
  getCollegeTypeCount,
  getHasCollegeOnly,
  getHasAK529Only,
  getHasNAT529Only,
} from 'src/redux/modules/productTypes/productType.selectors';
import { isCustomerWebViewEnabled } from 'src/redux/modules/authentication/authentication.module.selectors';
import { isSalesforceRep } from 'src/redux/modules/authentication/authentication.module.selectors';
import { resetQCDFundsValue } from 'src/redux/modules/qcd/qcd.module';
import { isRestrictedAddressChange } from 'src/redux/modules/qcd/qcd.selectors';
import { selectDeliveryMethod } from 'src/redux/modules/sellDeliveryMethod/actions';
import { getDeliveryMethod } from 'src/redux/modules/sellDeliveryMethod/sellDeliveryMethod.selectors';
import {
  get529MaximumAmount,
  getAddress,
  getEffectiveAddressChangedFlag,
  getEffectiveDate,
  getIsAddressChangedOnSameDay,
  getIsBanksWithStatus,
  getIsCollapsedBankList,
  getIsEFT,
  getIsUserWithAtleastOneRMDEligibleFund,
  getMultipleAddressFlag,
  getSellBankList,
  getStopMailFlag,
  getStopTransfer,
  getUnavailableText,
  getZeroState,
  getZeroStateEffectiveDate,
} from 'src/redux/modules/sellTransaction/sellTransaction.selectors';
import {
  getPersonalInformationData,
  getUserAddress,
} from 'src/redux/modules/user/PersonalInformation/personalInformation.selectors';
import {
  DELIVERY_DIRECT_DEPOSIT,
  DELIVERY_EXPRESS_DELIVERY,
  DELIVERY_MAIL_CHECK,
  DELIVERY_MAIL_CHECK_QCD,
  DELIVERY_IN_KIND,
  DELIVERY_MAIL_CHECK_TO_SCHOOL,
  DELIVERY_MAIL_CHECK_TO_CHARITY,
  ADD_SCHOOL_MODAL,
  ADD_CHARITY_MODAL,
} from 'src/settings/settings';
import { appendBasePath } from 'src/utils/nav.utils';
import {
  isAutomaticSell,
  isAppSell,
  isCollegeDistribute,
  isSell,
  isQCD,
} from 'src/utils/transactions-util';
import BankSelect from '../../FundingSource/BankSelect/BankSelect';
import If from '../../Shared/If/If';
import StepExpanded from '../../Shared/StepExpanded/StepExpanded';
import DeliveryMethod from '../DeliveryMethod/DeliveryMethod';
// import DeliveryMethodEstimation from '../DeliveryMethodEstimation/DeliveryMethodEstimation';
import MailACheck from '../MailACheck/MailACheck';
import ZeroState from '../ZeroState/ZeroState';
import DailyMaximumText from './DailyMaximumText';
import './DeliveryMethodForm.scss';
import { getProductTypes } from '../../../redux/modules/productTypes/productType.selectors';
import { ProductTypeEntity } from '../../../redux/modules/productTypes/types';
import { hasRasFundsOnly } from '../../../redux/modules/shoppingCart/shoppingCart.selectors';
import Button from '../../Shared/Button/Button';
import { ButtonType } from '../../Shared/Button';
import { openModal } from '../../../redux/modules/modals/actions';
import { getAllSchools } from '../../../redux/modules/addSchool//existingSchools.selector';
import CharityList from '../../QCD/QCDLanding/CharityList';
import SchoolAddress from 'src/components/CollegeDistribute/CollegeDistributeSteps/SchoolAddress';
import { setIsDistributeToSchool } from 'src/redux/modules/sellDeliveryMethod/distributeToSchool.module';
import PhoneNumberBranding from 'src/components/Branding/PhoneNumberBranding';
import carat_right from 'src/assets/images/carat_right.png';
import { ThunkDispatch } from 'redux-thunk';
import styles from '../../Shared/APPText/APPText.module.scss';

export const DeliveryMethodForm: React.VFC = () => {
  const dispatch: ThunkDispatch<any, any, any> = useDispatch();
  const address = useSelector(getAddress);
  const userAddress = useSelector(getUserAddress);
  const collegePlanType = useSelector(getCollegePlanType);
  const collegeTypeCount = useSelector(getCollegeTypeCount);
  const effectiveAddressChangedFlag = useSelector(
    getEffectiveAddressChangedFlag
  );
  const effectiveDate = useSelector(getEffectiveDate);
  const eligibleBanks = useSelector(getEligibleBanks);
  const isAddressChangedOnSameDay = useSelector(getIsAddressChangedOnSameDay);
  const isAddressChange = useSelector(isRestrictedAddressChange);
  const isBanksWithStatus = useSelector(getIsBanksWithStatus);
  const isCollapsedBankList = useSelector(getIsCollapsedBankList);
  const isEFT = useSelector(getIsEFT);
  const isUserWithAtleastOneRMDEligibleFund = useSelector(
    getIsUserWithAtleastOneRMDEligibleFund
  );
  const multipleAddressFlag = useSelector(getMultipleAddressFlag);
  const selectedBank = useSelector(getSelectedBank);
  const sellBankList = useSelector(getSellBankList);
  const stopMail = useSelector(getStopMailFlag);
  const stopTransfer = useSelector(getStopTransfer);
  const unavailableText = useSelector(getUnavailableText);
  const zeroStateEffectiveDate = useSelector(getZeroStateEffectiveDate);
  const zeroStateFlag = useSelector(getZeroState);
  const deliveryMethod = useSelector(getDeliveryMethod);
  const personalData = useSelector(getPersonalInformationData);
  const isSalesforceRepEnabled = useSelector(isSalesforceRep);
  const customerWebViewEnabled = useSelector(isCustomerWebViewEnabled);
  const hasCollegeOnly = useSelector(getHasCollegeOnly);
  const maxRedumption = useSelector(get529MaximumAmount);
  const existingSchools = useSelector(getAllSchools);
  const hasAK529Only = useSelector(getHasAK529Only);
  const hasNAT529Only = useSelector(getHasNAT529Only);
  const productTypes: ProductTypeEntity = useSelector(getProductTypes);
  const hasRAS = productTypes.hasRAS;
  const hasRASOnly = useSelector(hasRasFundsOnly);

  useEffect(() => {
    if (eligibleBanks.length === 1) {
      if (!eligibleBanks[0].hasRedemptionHold) {
        dispatch(selectBank(eligibleBanks[0]));
      }
    }
  }, [dispatch, eligibleBanks]);

  const handleClick = useCallback(
    (selectedBank) => {
      dispatch(selectBank(selectedBank));
    },
    [dispatch]
  );

  const handleSchoolClick = useCallback(
    (selectedSchool) => {
      dispatch(updateSelectedSchool(selectedSchool));
    },
    [dispatch]
  );

  const deliveryMethodSelection = useCallback(
    (_deliveryMethod) => {
      dispatch(selectDeliveryMethod(_deliveryMethod));
      if (isQCD()) {
        dispatch(resetQCDFundsValue());
      }

      if (_deliveryMethod === DELIVERY_MAIL_CHECK_TO_SCHOOL) {
        dispatch(setIsDistributeToSchool(true));
      } else {
        dispatch(setIsDistributeToSchool(false));
      }
      if (deliveryMethod !== _deliveryMethod) {
        if (eligibleBanks.length > 1) {
          dispatch(selectBank(undefined));
          showMoreBanks(false)(dispatch);
        }
        dispatch(updateSelectedSchool(null));
      }
    },
    [deliveryMethod, dispatch, eligibleBanks.length]
  );

  const numberOfEligibleBanks = eligibleBanks.length;

  return (
    <div className="row delivery-method-form-container">
      <StepExpanded>
        <If test={zeroStateFlag}>
          <div className="col-md-12 col-xs-12">
            <ZeroState
              collegePlanType={collegePlanType}
              collegeTypeCount={collegeTypeCount}
              customerWebViewEnabled={customerWebViewEnabled}
              effectiveAddressChangedFlag={effectiveAddressChangedFlag}
              eligibleBanks={eligibleBanks}
              isAddressChangedOnSameDay={isAddressChangedOnSameDay}
              isBanksWithStatus={isBanksWithStatus}
              isSalesforceRep={isSalesforceRepEnabled}
              numberOfEligibleBanks={numberOfEligibleBanks}
              stopMail={stopMail}
              stopTransfer={stopTransfer}
              zeroStateEffectiveDate={zeroStateEffectiveDate}
            />
          </div>
        </If>
        <If test={!zeroStateFlag}>
          <div className="col-md-6 col-xs-12 delivery-method-form-delivery-options">
            <If test={isCollegeDistribute()}>
              <DeliveryMethod
                className={'e2e-mail-check-to-school'}
                deliveryMethod={deliveryMethod}
                heading={'Mail a check to a school'}
                id={'mail-check-to-school'}
                // image={mailCheck}
                numberOfBanks={numberOfEligibleBanks}
                showDeliveryMethod={DELIVERY_MAIL_CHECK_TO_SCHOOL}
                onSelect={deliveryMethodSelection}
                {...{ personalData, unavailableText }}
              />
            </If>
            {isQCD() && (
              <>
                <DeliveryMethod
                  className={'e2e-mail-check-to-charity blocked_data'}
                  heading={'Send a check directly to my chosen charity'}
                  id={'mail-check-to-charity'}
                  //image={mailCheck}
                  numberOfBanks={numberOfEligibleBanks}
                  showDeliveryMethod={DELIVERY_MAIL_CHECK_TO_CHARITY}
                  onSelect={deliveryMethodSelection}
                  {...{ deliveryMethod, personalData, unavailableText }}
                />
                <DeliveryMethod
                  className={'e2e-mail-check blocked_data'}
                  heading={'Mail a check to my address of record'}
                  id={'mail-check-qcd'}
                  //image={mailCheck}
                  numberOfBanks={numberOfEligibleBanks}
                  showDeliveryMethod={DELIVERY_MAIL_CHECK_QCD}
                  onSelect={deliveryMethodSelection}
                  {...{ deliveryMethod, personalData, unavailableText }}
                />
              </>
            )}
            {!isQCD() && (
              <DeliveryMethod
                className={'e2e-direct-deposit'}
                deliveryMethod={deliveryMethod}
                heading={
                  <span>
                    Direct deposit{' '}
                    <span className="delivery-method-form-show-delivery-options">
                      {' '}
                      to a bank
                    </span>
                  </span>
                }
                id={'direct-deposit'}
                //image={directDeposit}
                numberOfBanks={numberOfEligibleBanks}
                personalData={personalData}
                showDeliveryMethod={DELIVERY_DIRECT_DEPOSIT}
                unavailableText={!unavailableText}
                onSelect={deliveryMethodSelection}
              />
            )}
            {!isQCD() && (
              <DeliveryMethod
                className={'e2e-mail-check'}
                heading={'Mail a check to address on record'}
                id={'mail-check'}
                //image={mailCheck}
                numberOfBanks={numberOfEligibleBanks}
                showDeliveryMethod={DELIVERY_MAIL_CHECK}
                onSelect={deliveryMethodSelection}
                {...{ deliveryMethod, personalData, unavailableText }}
              />
            )}
            {!isAutomaticSell() && !isQCD() && (
              <DeliveryMethod
                className={'e2e-express-delivery'}
                heading={
                  <span>
                    <span className="delivery-method-form-show-delivery-options">
                      Wire transfer to bank
                    </span>
                  </span>
                }
                id={`express-delivery-${DELIVERY_EXPRESS_DELIVERY}`}
                //image={expressMoney}
                numberOfBanks={numberOfEligibleBanks}
                showDeliveryMethod={DELIVERY_EXPRESS_DELIVERY}
                onSelect={deliveryMethodSelection}
                {...{ deliveryMethod, personalData, unavailableText }}
              />
            )}
            {isAppSell() && !hasRASOnly && (
              <DeliveryMethod
                className={'e2e-express-delivery'}
                heading={
                  <span>
                    <span className="delivery-method-form-show-delivery-options">
                      In-Kind transfer
                    </span>
                    <span className="hidden-md hidden-lg">
                      In-Kind transfer
                    </span>
                  </span>
                }
                id={`express-delivery-${DELIVERY_IN_KIND}`}
                //image={inKindTransfer}
                numberOfBanks={numberOfEligibleBanks}
                showDeliveryMethod={DELIVERY_IN_KIND}
                onSelect={deliveryMethodSelection}
                {...{ deliveryMethod, personalData, unavailableText }}
              />
            )}
          </div>
          <div
            className={`e2e-bank-container col-md-6 col-xs-12 ${
              isEmpty(deliveryMethod)
                ? 'delivery-method-form-no-bank-container'
                : 'delivery-method-form-bank-container'
            }`}
          >
            {/* <DeliveryMethodEstimation
              className="delivery-method-form-show-delivery-options-mobile"
              numberOfBanks={numberOfEligibleBanks}
              {...{ deliveryMethod, personalData, unavailableText }}
            /> */}
            <If test={isEFT}>
              <If test={numberOfEligibleBanks > 0}>
                <div className="delivery-method-form-bank-heading e2e-bank-heading">
                  <If test={deliveryMethod === DELIVERY_DIRECT_DEPOSIT}>
                    <span>ACH</span> to bank on file:
                  </If>
                  <If test={deliveryMethod === DELIVERY_EXPRESS_DELIVERY}>
                    <span>Wire transfer</span> to bank on file:
                  </If>
                </div>
                {sellBankList.map((bank, i) => (
                  <BankSelect
                    key={i}
                    bank={{
                      ...bank,
                      deliveryMethod: deliveryMethod,
                    }}
                    bankIndex={`${i}`}
                    className={`e2e-sell-bank delivery-method-form-sell-bank-name ${
                      sellBankList.length === 1
                        ? 'delivery-method-form-single-bank'
                        : ''
                    }`}
                    numberOfBanks={numberOfEligibleBanks}
                    selectedBank={selectedBank}
                    onBankClick={handleClick}
                  />
                ))}
                <If test={isCollapsedBankList}>
                  <div className="delivery-method-form-view-banks">
                    <a
                      className="e2e-view-all-banks college-branded-link"
                      onClick={() => showMoreBanks(true)(dispatch)}
                    >
                      {' '}
                      View all banks
                    </a>
                  </div>
                </If>

                <div>
                  <DailyMaximumText
                    {...{
                      deliveryMethod,
                      personalData,

                      customerWebViewEnabled,
                    }}
                    isSalesforceRep={isSalesforceRepEnabled}
                  />
                </div>
              </If>
              <If test={numberOfEligibleBanks === 0}>
                <div className="e2e-no-bank-container">
                  <div className="delivery-method-form-no-bank-heading">
                    <img
                      alt=""
                      className="delivery-method-form-error-icon"
                      src={errorIcon}
                    />
                    No bank on file
                  </div>
                  <div className="delivery-method-form-no-bank-description">
                    <div className="delivery-method-form-space">
                      {' '}
                      You currently do not have a bank on file.
                    </div>
                    <div className="delivery-method-form-space">
                      {' '}
                      If you would like to add a bank, please note that during
                      the 5 calendar days following a newly added bank, proceeds
                      from a redemption submitted online can only be sent by a
                      check or to a previously linked bank account.
                    </div>
                    <div>
                      {' '}
                      You can{' '}
                      {!customerWebViewEnabled && isSalesforceRepEnabled ? (
                        <span>add a bank</span>
                      ) : (
                        <span>
                          <a
                            className="text-nowrap college-branded-link"
                            href={`${config.url}${appendBasePath('/addbank')}`}
                          >
                            add a bank
                          </a>
                        </span>
                      )}{' '}
                      now, or we'll remind you after completing this
                      transaction.
                    </div>
                  </div>
                </div>
              </If>
            </If>
            <If test={deliveryMethod === DELIVERY_MAIL_CHECK_TO_CHARITY}>
              <div className="distribute-to-charity-container blocked_data">
                <div className="distribute-to-charity-heading">
                  Send a check to charity: 
                </div>
                <div>
                  {/* TODO - display the charities */}
                  <CharityList deliveryMethod={deliveryMethod} />
                </div>
                <div className="contact-advisor-button">
                  <Button
                    applyBranding
                    buttonType={ButtonType.SECONDARY}
                    className="add-charity-btn"
                    id="add-charity-btn"
                    onClick={() =>
                      dispatch(
                        openModal(ADD_CHARITY_MODAL, {
                          deliveryMethod: deliveryMethod,
                        })
                      )
                    }
                  >
                    Add a Charity
                  </Button>
                </div>
              </div>
            </If>
            <If test={deliveryMethod === DELIVERY_MAIL_CHECK_QCD}>
              <If test={isAddressChange && !multipleAddressFlag}>
                <div className="distribute-to-charity-container blocked_data">
                  <MailACheck
                    address={address}
                    customerWebViewEnabled={customerWebViewEnabled}
                    effectiveAddressChangedFlag={effectiveAddressChangedFlag}
                    effectiveDate={effectiveDate}
                    hasCollegeOnly={hasCollegeOnly}
                    isAddressChangedOnSameDay={isAddressChangedOnSameDay}
                    isSalesforceRep={isSalesforceRepEnabled}
                    maxRedumption={maxRedumption}
                    multipleAddressFlag={multipleAddressFlag}
                  />
                </div>
              </If>
              <If test={!isAddressChange || multipleAddressFlag}>
                <div className="distribute-to-charity-container blocked_data">
                  <div>
                    {/* TODO - display the charities */}
                    <CharityList deliveryMethod={deliveryMethod} />
                  </div>
                  <div className="contact-advisor-button">
                    <Button
                      applyBranding
                      buttonType={ButtonType.SECONDARY}
                      className="add-charity-btn"
                      id="add-charity-btn"
                      onClick={() =>
                        dispatch(
                          openModal(ADD_CHARITY_MODAL, {
                            deliveryMethod: deliveryMethod,
                          })
                        )
                      }
                    >
                      Add a Charity
                    </Button>
                  </div>
                  {!multipleAddressFlag && (
                    <>
                      <div className="mailing-address">Mailing address:</div>
                      <div className="mailing-address-address">
                        <Address address={userAddress} />
                      </div>
                      <span className="update-address">
                        <p>
                          If this is not your current address, please update
                          your{' '}
                          {!(
                            !customerWebViewEnabled && isSalesforceRepEnabled
                          ) ? (
                            <a
                              className="text-nowrap college-branded-link mail-a-check-link"
                              href={`${config.url}/usis/my-accounts/profile/contact-information`}
                            >
                              Contact Information.
                            </a>
                          ) : (
                            <span className="check">current address</span>
                          )}
                        </p>
                        <p>
                          If you change your address of record, for the next 15
                          calendar days you will be unable to redeem shares
                          online and have the check sent to your new address.
                        </p>
                      </span>
                    </>
                  )}
                  {multipleAddressFlag && (
                    <div>
                      <h3 className="mailing-address-address">
                        Multiple addresses on File
                      </h3>
                      <div className="update-address">
                        <span className="check">
                          Checks will be sent to the mailing address associated
                          with each fund selected.
                        </span>{' '}
                        You will be able to review all addresses before
                        submitting in Step 4.
                      </div>
                    </div>
                  )}
                </div>
              </If>
            </If>
            <If test={deliveryMethod === DELIVERY_MAIL_CHECK}>
              <MailACheck
                address={address}
                customerWebViewEnabled={customerWebViewEnabled}
                effectiveAddressChangedFlag={effectiveAddressChangedFlag}
                effectiveDate={effectiveDate}
                hasCollegeOnly={hasCollegeOnly}
                isAddressChangedOnSameDay={isAddressChangedOnSameDay}
                isSalesforceRep={isSalesforceRepEnabled}
                maxRedumption={maxRedumption}
                multipleAddressFlag={multipleAddressFlag}
              />
            </If>
            <If test={deliveryMethod === DELIVERY_MAIL_CHECK_TO_SCHOOL}>
              <div className="distribute-to-school-container">
                {(hasAK529Only || hasNAT529Only) && (
                  <div className="distribute-to-school-note">
                    {`To make a payment to the University of Alaska or any of its
                    campuses, please `}
                    <PhoneNumberBranding />.
                  </div>
                )}
                <div className="distribute-to-school-heading">
                  Distribute to educational institution:
                </div>
                {existingSchools.length > 0 ? (
                  <React.Fragment>
                    {existingSchools.map((school, i) => (
                      <SchoolAddress
                        key={`${i}-${school.schoolName}`}
                        noOfSchools={existingSchools.length}
                        school={school}
                        onSchoolClick={handleSchoolClick}
                      />
                    ))}
                  </React.Fragment>
                ) : (
                  <></>
                )}
                <div className="distribute-to-school-description">
                  {`${
                    existingSchools.length > 0
                      ? ''
                      : 'You indicated that you would like to send a check to a school. '
                  }
                  The beneficiary will be the taxable party for this
                  distribution and will receive a 1099-Q for the current tax
                  year.`}
                </div>
                <div className="distribute-to-school-description">
                  {`${
                    existingSchools.length > 0
                      ? ''
                      : 'Select a school from the educational institution list that will receive the check. '
                  }
                  The maximum amount that may be
                  distributed from a 529 account is
                  ${' ' + maxRedumption + ' '}
                  per day.`}
                </div>
                {/*TODO: Add Logic for this button to launch add school modal*/}
                <Button
                  applyBranding
                  buttonType={ButtonType.SECONDARY}
                  className="add-school-btn"
                  disabled={existingSchools.length >= 1}
                  id="add-school-btn"
                  onClick={() => dispatch(openModal(ADD_SCHOOL_MODAL))}
                >
                  Select a School
                </Button>
              </div>
            </If>
            <If test={deliveryMethod === DELIVERY_IN_KIND}>
              <div>
                <If test={!hasRAS}>
                  <div className="in-kind-description">
                    Assets will leave your T. Rowe Price ActivePlus Portfolios
                    <sup className={styles.sup}>®</sup> account and will be
                    transferred into identically registered mutual fund IRAs.
                    In-kind transfers are ineligible for Retirement Advisory
                    Service accounts.
                  </div>
                </If>
                <If test={hasRAS}>
                  <div className="in-kind-description">
                    Assets will leave your T. Rowe Price ActivePlus Portfolios
                    <sup className={styles.sup}>®</sup> account and will be
                    transferred into identically registered mutual fund IRAs.
                    In-kind transfers are ineligible for Retirement Advisory
                    Service accounts.
                  </div>
                </If>
                <div className="in-kind-note">Please Note:</div>
                <div className="in-kind-disclaimer">
                  Under normal circumstances, T. Rowe Price Advisory Services
                  will process and execute withdrawal requests on the same
                  business day for requests that are received in good order by 1
                  p.m. eastern time (ET) on a day that the New York Stock
                  Exchange (NYSE) is open for business ("business day"). Under
                  normal circumstances, T. Rowe Price Advisory Services will use
                  its best efforts to process and execute withdrawal requests on
                  the same business day for requests that are received in good
                  order between 1 p.m. and 3 p.m. on the business day.
                  Withdrawal requests received after 3 p.m. ET on a given
                  business day will be processed the next business day. Full
                  account closeout requests received in good order by 1 p.m. ET
                  on a given business day will generally be processed and
                  executed two or more business days after the request is made;
                  however, depending on the nature and timing of the request,
                  certain full closeouts may take longer to fully process.
                </div>
              </div>
            </If>
            {!isAutomaticSell() && !isQCD() && (
              <If test={isEmpty(deliveryMethod)}>
                <div className="delivery-method-form-select-delivery-method">
                  {isCollegeDistribute()
                    ? 'To continue, choose how you would like your distribution delivered.'
                    : 'To continue, choose how you would like to have your assets delivered.'}
                </div>
              </If>
            )}
          </div>
        </If>
      </StepExpanded>
      {!isAutomaticSell() && (
        <div className="e2e-delivery-method-footer-text col-xs-12 delivery-method-form-other-delivery-options delivery-method-form-display-inline">
          <If
            test={
              !(
                isUserWithAtleastOneRMDEligibleFund &&
                (personalData?.age ?? -99) >= 72
              ) &&
              !isAppSell() &&
              !(!customerWebViewEnabled && isSalesforceRepEnabled) &&
              !isQCD()
            }
          >
            <span className="col-md-6 col-xs-12 delivery-method-form-text">
              {isCollegeDistribute()
                ? 'Want to exchange assets directly from one portfolio to another?'
                : 'Want to transfer assets directly from one fund to another?'}{' '}
            </span>
            <span>
              <If test={isCollegeDistribute()}>
                <a
                  className="college-branded-link delivery-method-form-underline-text"
                  href={`${config.url}/usis/transactions/college/exchange`}
                >
                  Start an Exchange
                </a>
              </If>
              <If test={isSell()}>
                <a
                  className="delivery-method-form-underline-text"
                  href={`${config.url}/usis/transactions/exchange`}
                >
                  Start an Exchange
                </a>
              </If>
            </span>
          </If>
          <If
            test={
              isUserWithAtleastOneRMDEligibleFund &&
              (personalData?.age ?? -99) >= 72 &&
              !isAppSell() &&
              !isQCD()
            }
          >
            <span className="hidden-xs delivery-method-form-text">
              Other delivery options:{' '}
            </span>
            <span>
              {!customerWebViewEnabled && isSalesforceRepEnabled ? (
                <span></span>
              ) : (
                <span>
                  <a
                    className="delivery-method-form-underline-text"
                    href={`${config.url}/usis/transactions/exchange`}
                  >
                    Move assets to an existing fund
                  </a>{' '}
                </span>
              )}
            </span>
            <span className="hidden-xs">
              {!customerWebViewEnabled && isSalesforceRepEnabled ? (
                <span>To make</span>
              ) : (
                <span>or make</span>
              )}{' '}
              a
            </span>
            <span>
              {!customerWebViewEnabled && isSalesforceRepEnabled ? (
                <span>
                  <a
                    className="delivery-method-form-underline-text"
                    href={`${config.url}/content/dam/iinvestor/Forms/qualified-charitable-distribution-ira.pdf`}
                    rel="noopener noreferrer"
                    target="_blank"
                  >
                    {' '}
                    Qualified Charitable Distribution
                  </a>{' '}
                  from a retirement account only, deliver the corresponding form
                  in DocuSign.
                </span>
              ) : (
                <span>
                  <a
                    className="delivery-method-form-underline-text"
                    href={`${config.url}/usis/transactions/qcd/landing`}
                    rel="noopener noreferrer"
                    target="_self"
                  >
                    {' '}
                    Qualified Charitable Distribution
                  </a>{' '}
                  from an IRA.
                </span>
              )}
            </span>
          </If>
          <If test={isAppSell() && !hasRASOnly}>
            <span className="hidden-xs delivery-method-form-text">
              Other delivery options:{' '}
            </span>
            <span>
              {!customerWebViewEnabled && isSalesforceRepEnabled ? (
                <span></span>
              ) : (
                <span>
                  <a
                    className="delivery-method-form-underline-text"
                    href={`${config.url}/usis/transactions/exchange`}
                  >
                    Exchange assets between eligible investments
                  </a>{' '}
                </span>
              )}
            </span>
          </If>
          <If
            test={isQCD() && deliveryMethod === DELIVERY_MAIL_CHECK_TO_CHARITY}
          >
            <div className="check-info-container">
              <div className="check-info-header">
                The check will be made payable to the charity, but the following{' '}
                personal information will be included in the mailing sent to{' '}
                your charity:
              </div>
              <ul className="check-info-list">
                <li>Your full name</li>
                <li>Your address</li>
              </ul>
            </div>
            <div>
              {!(!customerWebViewEnabled && isSalesforceRepEnabled) && (
                <a
                  className="view-check"
                  href={PdfSendCheckCharity}
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  View a check sample{' '}
                  <img
                    alt="right arrow"
                    className="right-arrow"
                    src={carat_right}
                  />
                </a>
              )}
            </div>
          </If>
          <If test={isQCD() && deliveryMethod === DELIVERY_MAIL_CHECK_QCD}>
            <div className="check-info-container">
              <div className="check-info-header">
                The check will be made payable to the charity, but the following
                personal information will be included on the check:
              </div>
              <ul className="check-info-list">
                <li>Your address</li>
              </ul>
            </div>
            <div>
              {!(!customerWebViewEnabled && isSalesforceRepEnabled) && (
                <a
                  className="view-check"
                  href={PdfMailCheckAddress}
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  View a check sample{' '}
                  <img alt="right arrow" src={carat_right} />
                </a>
              )}
            </div>
          </If>
        </div>
      )}
    </div>
  );
};

export default DeliveryMethodForm;
